import Icon from 'vue-awesome/components/Icon'

Icon.register({
  pin_drop_rounded: {
    paths: [
      {
        d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 3.49 3.62 8.19 5.23 10.12.4.48 1.13.48 1.53 0C14.38 16.19 18 11.49 18 8zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 11-4 0zM5 21c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z'
      }
    ],
    width: '24',
    height: '24'
  }
})
